import type { ICollection, IQuotes, IScrBaseline } from '@/interfaces'
import { Collection, Quotes } from '@/models/'

export class ScrBaseline implements IScrBaseline {
	subjobId: number
	quoteSignedAtSCR: boolean
	paidAtSCR: boolean
	arLowRiskAtSCR: boolean
	arAmountAtSCR: number
	arAmount90AtSCR: number
	arAmount60AtSCR: number
	arAmount30AtSCR: number
	arAmount0AtSCR: number
	contractAmountAtSCR: number
	contractLowRiskAtSCR: boolean
	quotes: ICollection<IQuotes>

	constructor({
		subjobId,
		quoteSignedAtSCR,
		paidAtSCR,
		arLowRiskAtSCR,
		arAmountAtSCR,
		arAmount90AtSCR,
		arAmount60AtSCR,
		arAmount30AtSCR,
		arAmount0AtSCR,
		contractAmountAtSCR,
		contractLowRiskAtSCR,
		quotes
	}: IScrBaseline) {
		this.subjobId = subjobId
		this.quoteSignedAtSCR = quoteSignedAtSCR
		this.paidAtSCR = paidAtSCR
		this.arLowRiskAtSCR = arLowRiskAtSCR
		this.arAmountAtSCR = arAmountAtSCR
		this.arAmount90AtSCR = arAmount90AtSCR
		this.arAmount60AtSCR = arAmount60AtSCR
		this.arAmount30AtSCR = arAmount30AtSCR
		this.arAmount0AtSCR = arAmount0AtSCR
		this.contractAmountAtSCR = contractAmountAtSCR
		this.contractLowRiskAtSCR = contractLowRiskAtSCR
		this.quotes = new Collection(Quotes, quotes)
	}
}
